export const BREAKPOINT = {
    xs: 480 as const,
    sm: 576 as const,
    md: 768 as const,
    lg: 992 as const,
    xl: 1200 as const,
    xxl: 1600 as const,
    xxxl: 1800 as const,
} as const;
